import React from "react";
import "./welcome.css";
import { Typography } from "@mui/material";

function Welcome() {

  return (
    <div className="welcome-container">
      <Typography variant="h3">Bienvenidos</Typography>
      <Typography>
        ¡Bienvenido a tu hogar en nuestra residencia! Estamos encantados de que
        formes parte de nuestra comunidad. Aquí encontrarás toda la información
        necesaria para hacer de tu estancia una experiencia cómoda y agradable.
        No dudes en explorar y aprovechar todos los recursos disponibles.
        ¡Estamos aquí para apoyarte en lo que necesites!
      </Typography>
      <h1> </h1>
      <Typography variant="h6">Pagos</Typography>
      <h1> </h1>
      <div></div>
      <Typography>
        Cuentas a nombre de <strong>Hannia Aguilar Salas</strong>
      </Typography>
      <ul>
        <Typography>
          <li>Sinpe: 8680-9574</li>
        </Typography>
        <Typography>
          <li>Cuenta IBAN BAC: CR07010200009616043113</li>
        </Typography>
      </ul>
    </div>
  );

}

export default Welcome;
